import { FruitDef } from './types';

import cherryUrl     from '../img/cherry.png';
import strawberryUrl from '../img/strawberry.png';
import grapeUrl      from '../img/grape.png';
import dekoponUrl    from '../img/dekopon.png';
import persimmonUrl  from '../img/persimmon.png';
import appleUrl      from '../img/apple.png';
import pearUrl       from '../img/pear.png';
import peachUrl      from '../img/peach.png';
import pineappleUrl  from '../img/pineapple.png';
import melonUrl      from '../img/melon_512.png';
import watermelonUrl from '../img/watermelon_512.png';

// Tier table from the spec (3.2). Index 0 == tier 1.
export const FRUITS: FruitDef[] = [
  { tier: 1,  name: 'Cherry',     radius: 16,  color: '#E63946', points: 1  },
  { tier: 2,  name: 'Strawberry', radius: 22,  color: '#F87171', points: 3  },
  { tier: 3,  name: 'Grape',      radius: 30,  color: '#A855F7', points: 6  },
  { tier: 4,  name: 'Dekopon',    radius: 38,  color: '#FB923C', points: 10 },
  { tier: 5,  name: 'Persimmon',  radius: 46,  color: '#EA580C', points: 15 },
  { tier: 6,  name: 'Apple',      radius: 56,  color: '#DC2626', points: 21 },
  { tier: 7,  name: 'Pear',       radius: 66,  color: '#FDE047', points: 28 },
  { tier: 8,  name: 'Peach',      radius: 78,  color: '#FBCFE8', points: 36 },
  { tier: 9,  name: 'Pineapple',  radius: 92,  color: '#FACC15', points: 45 },
  { tier: 10, name: 'Melon',      radius: 108, color: '#86EFAC', points: 55 },
  { tier: 11, name: 'Watermelon', radius: 128, color: '#16A34A', points: 66 },
];

const SPRITE_URLS = [
  cherryUrl, strawberryUrl, grapeUrl, dekoponUrl, persimmonUrl, appleUrl,
  pearUrl, peachUrl, pineappleUrl, melonUrl, watermelonUrl,
];

const sprites: HTMLImageElement[] = [];

export function fruitDef(tier: number): FruitDef {
  return FRUITS[tier - 1];
}

export function fruitRadius(tier: number): number {
  return FRUITS[tier - 1].radius;
}

export function spriteFor(tier: number): HTMLImageElement | undefined {
  return sprites[tier - 1];
}

export function preloadSprites(): Promise<void> {
  return Promise.all(SPRITE_URLS.map((url, i) =>
    new Promise<void>((resolve) => {
      const img = new Image();
      img.onload = () => { sprites[i] = img; resolve(); };
      img.onerror = () => resolve(); // fall back to ctx.arc fill if a sprite is missing
      img.src = url;
    }),
  )).then(() => undefined);
}
